import { Component } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UnSubscribeService } from '../../services';

@Component({
    selector: 'unsubscribe-modal',
    templateUrl: './unsubscribe-modal.component.html',
    standalone: false
})
export class UnsubscribeModalComponent {
    private token: string;
    public emailName: string;
    public schoolName: string;
    private navigationOptions: NavigationExtras;
    private data: any;

    constructor(
        private route: ActivatedRoute,
        private unsubscribeService : UnSubscribeService,
        private router: Router
    ) {}

    ngOnInit() {
        this.navigationOptions = {
            skipLocationChange: true,
            relativeTo: this.route.parent
        };

        this.token = this.route.snapshot.paramMap.get('token');
        this.unsubscribeService.unsubscribe(this.token, {value: false}).subscribe(
            res => {
                this.loadPage(res, 'unsubscribe')
            }
        )
    }

    resubscribe() {
        this.unsubscribeService.unsubscribe(this.token, {value: true}).subscribe(
            res => {
                this.loadPage(res, 'subscribe')
            }
        )
    }

    gotoEmailPreferences() {
        window.location.href = this.data.preferenceLink;
    }

    loaddata() {
        this.emailName = this.data.emailName;
        this.schoolName = this.data.systemTitle;
    }

    loadPage(res, title) {
        this.data = res;
        if(res.status && res.status == 201) {
            this.loaddata();
            if (title == 'subscribe') {
                this.router.navigate(['resubscribe'], {
                    ...this.navigationOptions,
                    queryParams: {
                        emailType: this.emailName,
                        schoolName: this.schoolName,
                        preferenceLink: this.data.preferenceLink
                    }
                });
            }
        } else {
            this.router.navigate(['subscribefail'], {
                ...this.navigationOptions,
                queryParams: {
                    title: title,
                    preferenceLink: this.data.preferenceLink
                }
            });
        }
    }
}
